module.exports = __webpack_public_path__ + "static/LogoYellowEN-768a1ecbfa4a6b582cf90bdbcf11f587.svg";